/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {checkVersion} from '../api'

export const useMutationCheckVersion = createReactQueryMutationHook('checkVersion', checkVersion)
